/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect } from "react";
import { CiMail, CiLocationOn, CiCalendarDate } from "react-icons/ci";
import { FaLinkedin } from "react-icons/fa";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { IoCallOutline } from "react-icons/io5";
import { PiSquaresFourLight } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { useStaticData } from "../../../../Providers/Data";
import { Contentcard } from "../Discover/DashBoard";
import { TableCard } from "./UnlockedCreatorFull";

export const UnlockedCreatorFullSample = () => {
  const navigate = useNavigate();
  const [InfluencerInfo] = useState({
    name: "Ravi Ahirwar",
    email: "raviahirwar660@gmail.com",
    profile:
      "https://media.licdn.com/dms/image/D4D03AQFSxQcmkzSYww/profile-displayphoto-shrink_100_100/0/1693739553701?e=1711584000&v=beta&t=uGYxOuNll9laZBy1P_OuUMUe4nzs3ouauYKDj0NBEtE",
    mobile: "+918692006538",
    linkedinLink: "https://linkedin.com/in/ravi-ahirwar",
    coverPhoto:
      "https://anchors-collab.s3.ap-south-1.amazonaws.com/collabInfluncer/1706343192926-kkmzzfpidw.png",
    fbLink: "",
    followers: {
      linkedin: "6001",
      twitter: null,
      fb: null,
      telegram: "666878",
      insta: "450",
      website: "",
    },
    instaLink: "https://www.instagram.com/ravilex70024/",
    tagline: "Founder, anchors.in",
    telegramLink: "https://www.instagram.com/ravilex70024/",
    twitterLink: "",
  });
  const [InfluencerCollabInfo] = useState({
    _id: "65b4bbbac9581343f0a60fe3",
    data: [
      {
        companyName: "tfg",
        companyUrl: "tg",
        companyProfile:
          "https://anchors-collab.s3.ap-south-1.amazonaws.com/collabCompanies/1706343354567-nzwcrnngul.png",
        postLink: "fy",
        goals: [],
        _id: "65c09e4977f1166ab8e0555f",
      },
      {
        companyName: "Boat Lifestyle",
        companyUrl: "ttfsf sdfs dfsdfvs df",
        companyProfile: "",
        postLink: "atsaf sdtysavf sadf",
        goals: ["Awareness"],
        _id: "65c09e4977f1166ab8e05560",
      },
      {
        companyName: "alphahive anchors pvt ltd",
        companyUrl: "https://www.anchors.in",
        companyProfile:
          "https://anchors-collab.s3.ap-south-1.amazonaws.com/collabCompanies/1706960937871-cxsayzkglr.png",
        postLink: "https://www.linkedin.com/feed/",
        goals: ["Awareness", "Sales"],
        _id: "65c09e4977f1166ab8e05561",
      },
      {
        companyName: "sdsdfdf",
        companyUrl: "dxdxfzg",
        companyProfile:
          "https://anchors-collab.s3.ap-south-1.amazonaws.com/collabCompanies/1706960938305-grzuxodkqj.png",
        postLink: "dsgrdr",
        goals: [
          "Audience Growth",
          "Conversions",
          "Engagement",
          "Traffic",
          "Awareness",
          "Product Launch",
          "Sales",
        ],
        _id: "65c09e4977f1166ab8e05562",
      },
      {
        companyName: "wefebf er",
        companyUrl: "efybwesf er",
        companyProfile: "",
        postLink: "sefhesfbe r ",
        goals: ["Audience Growth"],
        _id: "65c09e4977f1166ab8e05563",
      },
    ],
    completionPercent: 0,
  });
  const [InfluencerMonetizationInfo] = useState({
    _id: "65b4bbdbc9581343f0a60fea",
    data: [
      {
        platformName: "Patreon",
        profileLink: "anchors.in/ravi-ahirwar",
        paidAudience: 3245,
        methods: [
          "Digital Products",
          "1:1 Session",
          "Live Events",
          "Physical Products",
          "Courses",
          "Paid Community",
          "Video Content",
          "Merchandise",
          "Consulting",
          "Document",
          "Tips",
          "Ebooks",
          "Other",
        ],
        _id: "65be379e77f1166ab8e04294",
      },
      {
        platformName: "anchors",
        profileLink: "sfsfdsf",
        paidAudience: 3451,
        methods: ["Tips", "Paid Community", "Podcast", "Consulting"],
        _id: "65be379e77f1166ab8e04295",
      },
    ],
    completionPercent: 0,
  });
  const [InfluencerContentInfo] = useState({
    _id: "65b4bbeac9581343f0a60ff0",
    categories: [
      "Tech Trends",
      "Career Development",
      "Innovation",
      "Finance Education",
      "Social Media Tips",
      "Collaboration Tips",
      "Career Transitions",
      "Coding Tutorials",
      "Other",
      "Upskilling",
    ],
    formats: ["Written Content", "Short-Form Videos", "Long Form Videos"],
    completionPercent: 0,
  });
  const [InfluencerAudienceInfo] = useState({
    _id: "65b4bc00c9581343f0a60ff5",
    types: [
      "Below 12th Class",
      "Corporate employee",
      "Founder",
      "Marketing Professionals",
      "Consultants",
      "Creatives Designers",
      "Finance Professionals",
      "Creatives Writer",
      "Healthcare Professionals",
    ],
    platforms: [
      {
        platform: "LinkedIn Profile",
        audience: 6000,
        link: "https://www.linkedin.com/",
        _id: "65c09eb777f1166ab8e055b5",
      },
      {
        platform: "Instagram Page",
        audience: 456,
        link: "rrtyhgfd",
        _id: "65c09eb777f1166ab8e055b6",
      },
    ],
    completionPercent: 0,
  });

  const [platformLogo, setPlatformLogo] = useState([]);
  const [platformNamelogo, setPlatformNamelogo] = useState([]);
  const staticDataState = useStaticData();

  useEffect(() => {
    async function getLogos1() {
      const result1 = await staticDataState?.getLogoFromType("Platform Name");
      if (result1) {
        setPlatformLogo(result1);
      }
    }
    getLogos1();
  }, []);
  useEffect(() => {
    async function getLogos2() {
      const result2 = await staticDataState?.getLogoFromType(
        "Audience Platform"
      );
      if (result2) {
        setPlatformNamelogo(result2);
      }
    }
    getLogos2();
  }, []);

  const convertToReadableFormat = (number) => {
    if (Math.abs(number) >= 1000000000) {
      return (number / 1000000000).toFixed(1) + "B";
    } else if (Math.abs(number) >= 1000000) {
      return (number / 1000000).toFixed(1) + "M";
    } else if (Math.abs(number) >= 1000) {
      return (number / 1000).toFixed(1) + "K";
    } else {
      return number?.toString();
    }
  };

  const getDate = (date) => {
    const utcDate = new Date(date);

    // Convert UTC time to IST (Indian Standard Time)
    const istDate = new Date(utcDate.getTime());

    // Extract date components
    const day = String(istDate.getDate()).padStart(2, "0");
    const month = String(istDate.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = istDate.getFullYear();

    // Extract time components
    const hours = String(istDate.getHours()).padStart(2, "0");
    const minutes = String(istDate.getMinutes()).padStart(2, "0");
    const seconds = String(istDate.getSeconds()).padStart(2, "0");

    // Construct the formatted string
    const formattedDateTimeString = `${day}/${month}/${year} ${hours}:${minutes}:${seconds} IST`;
    return formattedDateTimeString;
  };

  return (
    <div className="w-full h-full">
      <div className="flex flex-col w-full h-auto px-[40px] py-[20px] align-left gap-[20px]">
        <p className="flex gap-[12px] text-[18px] font-[600] text-[#424242] ">
          <button
            onClick={() => navigate("/Brand/DashBoard/UnlockedInfluencer")}
          >
            <HiArrowNarrowLeft size={20} />
          </button>
          {"Creator Details"}
        </p>
        <div className="w-full font-inter items-center flex flex-col p-[40px] gap-[20px] bg-[#FAFAFA] rounded-[12px]">
          {/* creater details header */}
          <div className="w-full flex items-center justify-between px-[40px]">
            <div className="flex gap-[16px] items-center justify-center ">
              <img
                className="w-[80px] h-[80px] rounded-[50%] "
                src={
                  InfluencerInfo?.profile ||
                  "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/user.png"
                }
                onError={(e: any) => {
                  e.target.onerror = null; // Remove the event handler to prevent infinite loops
                  e.target.src =
                    "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/user.png";
                }}
                alt=""
              />
              <div>
                <p className=" text-[20px] font-[600] text-[#424242] ">
                  {InfluencerInfo?.name}
                </p>
                <p className="flex items-center gap-[4px] text-[16px] text-[#0076B2] font-[400] ">
                  <FaLinkedin color="#0076B2" />{" "}
                  {convertToReadableFormat(InfluencerInfo?.followers?.linkedin)}{" "}
                  Followers
                </p>
              </div>
            </div>
            <div className="flex flex-col gap-[12px]">
              <p className="flex gap-[8px] text-[#424242] text-[16px] ">
                {" "}
                <CiMail color="#FF5C5C" size={24} />{" "}
                {InfluencerInfo?.email || "Not Available"}
              </p>
              <p className="flex gap-[8px] text-[#424242] text-[16px] ">
                <IoCallOutline color="#FF5C5C" size={24} />{" "}
                {InfluencerInfo?.mobile || "Not Available"}
              </p>
            </div>
            <div className="flex flex-col gap-[12px]">
              <p className="flex gap-[8px] text-[#424242] text-[16px] ">
                {" "}
                <CiLocationOn color="#FF5C5C" size={24} /> India
              </p>
              <p className="flex gap-[8px] text-[#424242] text-[16px] ">
                <CiCalendarDate color="#FF5C5C" size={24} /> Unlocked On :
                {getDate(Date?.now())}
              </p>
            </div>
          </div>

          <div className="w-[95%] h-[1px] bg-[#EEEEEE]"></div>

          {/* creator collab experience */}
          {InfluencerCollabInfo && (
            <>
              {/* <div className=" w-full px-[40px]  flex item-start text-[16px] text-[#424242] font-[600] ">
                  <p>
                    Collab Experience{" "}
                    {`: ${InfluencerCollabInfo?.data?.length || 0}`}
                  </p>
                </div> */}
              {/* <div className="flex gap-[9px] w-full px-[40px] flex-wrap">
                  {InfluencerCollabInfo?.data?.map((item, index) => {
                    return (
                      <CreatorDetailCard
                        icon={undefined}
                        heading={`${
                          item?.companyName?.toUpperCase() || "Not Available"
                        }`}
                        proofLink={item?.postLink}
                        count={undefined}
                        data={item?.goals}
                        bg={"#EAEBFF"}
                      />
                    );
                  })}
                </div> */}
              <TableCard
                heading={"Collab Experience"}
                length={InfluencerCollabInfo?.data?.length}
                headers={[
                  "S. No. ",
                  "Company Name",
                  "Website",
                  "Post Link",
                  "Goals",
                ]}
                rows={InfluencerCollabInfo?.data?.map((item, index) => [
                  index + 1, // S.No.
                  `${item?.companyName || "Not Available"}`,
                  <div
                    onClick={() => {
                      if (!/^https?:\/\//i.test(item?.companyUrl)) {
                        const companyUrl = "https://" + item?.companyUrl;
                        return window.open(companyUrl, "_blank");
                      }

                      window.open(item?.companyUrl, "_blank");
                    }}
                    className="text-[#6183E4] cursor-pointer"
                  >
                    {item?.companyUrl.slice(0, 20) || "Not Available"}
                  </div>,
                  <div
                    onClick={() => {
                      if (!/^https?:\/\//i.test(item?.postLink)) {
                        const postLink = "https://" + item?.postLink;
                        return window.open(postLink, "_blank");
                      }

                      window.open(item?.postLink, "_blank");
                    }}
                    className="text-[#6183E4] cursor-pointer"
                  >
                    {`${item?.postLink?.slice(0, 20) || "Not Available"}...`}
                  </div>,

                  <div className="flex items-center justify-center">
                    {item?.goals?.length > 0
                      ? item?.goals?.map((item) => (
                          <div className="flex px-[12px] mr-[4px] py-[4px] rounded-[198px] bg-[#D1FAE5] align-center justify-center">
                            {item}
                          </div>
                        ))
                      : "Not Available"}
                  </div>,
                ])}
              />
              <div className="w-[95%] h-[1px] bg-[#EEEEEE]"></div>
            </>
          )}

          {/* creator Monetization Avenues*/}
          {InfluencerMonetizationInfo && (
            <>
              {/* <div className=" w-full px-[40px]  flex item-start text-[16px] text-[#424242] font-[600] ">
                  <p>
                  Monetization Avenues{" "}
                    {`: ${InfluencerMonetizationInfo?.data?.length || 0}`}
                  </p>
                </div>
                <div className="flex gap-[9px] w-full px-[40px] flex-wrap">
                  {InfluencerMonetizationInfo?.data?.map((item, index) => {
                    return (
                      <CreatorDetailCard
                        icon={platformLogo[0]?.[item?.platformName]}
                        heading={`${
                          item?.platformName?.toUpperCase() || "Not Available"
                        }`}
                        proofLink={item?.profileLink}
                        count={undefined}
                        data={item?.methods}
                        bg={"#FAECFF"}
                      />
                    );
                  })}
                </div> */}
              <TableCard
                heading={"Monetization Avenues"}
                length={InfluencerMonetizationInfo?.data?.length}
                headers={[
                  "S. No. ",
                  "Company Name",
                  "Profile Link",
                  "Services",
                  "Paid audience",
                ]}
                rows={InfluencerMonetizationInfo?.data?.map((item, index) => [
                  index + 1,
                  <div>
                    {platformLogo[0]?.[item?.platformName] && (
                      <img
                        style={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "50%",
                          marginRight: "12px",
                        }}
                        src={platformLogo[0]?.[item?.platformName]}
                        alt=""
                      />
                    )}
                    {item?.platformName || "Not Available"}
                  </div>,

                  <div
                    onClick={() => {
                      if (!/^https?:\/\//i.test(item?.profileLink)) {
                        const profileLink = "https://" + item?.profileLink;
                        return window.open(profileLink, "_blank");
                      }

                      window.open(item?.profileLink, "_blank");
                    }}
                    className="text-[#6183E4] cursor-pointer"
                  >
                    {`${item?.profileLink?.slice(0, 20) || "Not Available"}`}
                  </div>,
                  <div>
                    {item?.methods?.length > 0
                      ? item?.methods?.map((item) => (
                          <div className="flex px-[12px] mr-[4px] py-[4px] rounded-[198px] bg-[#D1FAE5] align-center justify-center">
                            {item}
                          </div>
                        ))
                      : "Not Available"}
                  </div>,

                  item?.paidAudience || "Not Available",
                ])}
              />
              <div className="w-[95%] h-[1px] bg-[#EEEEEE]"></div>
            </>
          )}

          {/* Content category */}
          <div className="w-full flex-col flex items-center justify-between gap-[20px] px-[40px]">
            {InfluencerContentInfo && (
              <>
                <Contentcard
                  icon={<PiSquaresFourLight color="#424242" size={18} />}
                  heading={"Content category"}
                  number={InfluencerContentInfo?.categories?.length}
                  type={InfluencerContentInfo?.categories}
                  borderRadius={"198px"}
                />
                <div className="w-[95%] h-[1px] bg-[#EEEEEE]"></div>
              </>
            )}
          </div>

          {/* Audience category */}
          <div className="w-full flex-col flex items-center justify-between gap-[20px] px-[40px]">
            {InfluencerAudienceInfo?.types?.length > 0 && (
              <>
                <Contentcard
                  icon={<PiSquaresFourLight color="#424242" size={18} />}
                  heading={"Audience category"}
                  number={InfluencerAudienceInfo?.types?.length}
                  type={InfluencerAudienceInfo?.types}
                  borderRadius={"198px"}
                />
                <div className="w-[95%] h-[1px] bg-[#EEEEEE]"></div>
              </>
            )}
          </div>

          {/* Audience Presence */}
          {InfluencerAudienceInfo?.platforms?.length > 0 && (
            <TableCard
              heading={"Audience Presence"}
              length={InfluencerAudienceInfo?.platforms?.reduce(
                (total, platform) => total + platform.audience,
                0
              )}
              headers={["S. No. ", "Platform Names", "No. of users", "Link"]}
              rows={InfluencerAudienceInfo?.platforms?.map((item, index) => [
                index + 1,
                <div>
                  {platformNamelogo[0]?.[item?.platform] && (
                    <img
                      style={{
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                        marginRight: "12px",
                      }}
                      src={platformNamelogo[0]?.[item?.platform]}
                      alt=""
                    />
                  )}
                  {item?.platform || "Not Available"}
                </div>,

                item?.audience || "Not Available",
                <div
                  onClick={() => {
                    if (!/^https?:\/\//i.test(item?.link)) {
                      const link = "https://" + item?.link;
                      return window.open(link, "_blank");
                    }

                    window.open(item?.link, "_blank");
                  }}
                  className="text-[#6183E4] cursor-pointer"
                >
                  {`${item?.link?.slice(0, 25) || "Not Available"}`}
                </div>,
              ])}
            />
          )}
        </div>
      </div>
    </div>
  );
};
